// Utility for replaceWithVNode (changes a string to regexp, with escaped special chars : '(cat|dog)' matches that literally instead of cat OR dog)
export default function toRegExp(s, caseInsensitive) {
	if (s instanceof RegExp) {
		return s;
	}
	return new RegExp((s + '').replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&'), caseInsensitive ? 'gi' : 'g');
}